import { useCallback, useEffect } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import { usePersistStore } from '@/store/persist'

const GridHelper = () => {
  const [gridHelper, setGridHelper] = usePersistStore((state) => [
    state.gridHelper,
    state.setGridHelper
  ])

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.shiftKey && event.key === 'G') setGridHelper(!gridHelper)
    },
    [gridHelper, setGridHelper]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  return gridHelper ? (
    <div className="z-grid pointer-events-none fixed bottom-0 left-0 right-0 top-0">
      <div className="absolute left-0 top-1/2 h-[.1rem] w-full -translate-y-1/2 bg-[red]/40" />
      <div className="absolute left-1/2 top-0 h-full w-[.1rem] -translate-x-1/2 bg-[red]/40" />

      <Container className="h-full">
        <Grid className="h-full">
          {Array(12)
            .fill(undefined)
            .map((_, index) => (
              <div key={index} className="col-span-1 h-full bg-[red]/10" />
            ))}
        </Grid>
      </Container>
    </div>
  ) : null
}

export default GridHelper
